// Styles
import "@/tailwind.css";
import "@/styles/main.scss";

// Layout
import Layout from "@/layouts/Layout";

function App() {
  return <Layout />;
}

export default App;
